
import { Button } from "@/components/ui/button";
import { FileCheck, Save } from "lucide-react";
import { CardFooter } from "@/components/ui/card";

interface PrescriptionActionsProps {
  handleSavePrescription: (status: "draft" | "issued") => void;
  existingDraft?: boolean;
}

export function PrescriptionActions({ handleSavePrescription, existingDraft }: PrescriptionActionsProps) {
  const handleCreateRx = () => {
    console.log('Create Rx button clicked!');
    console.log('Calling handleSavePrescription with status: issued');
    handleSavePrescription("issued");
  };

  const handleSaveDraft = () => {
    console.log('Save Draft button clicked!');
    console.log('Calling handleSavePrescription with status: draft');
    handleSavePrescription("draft");
  };

  return (
    <CardFooter className="flex flex-wrap gap-3 justify-between">
      <Button 
        variant="outline"
        onClick={handleSaveDraft}
      >
        <Save className="mr-2 h-4 w-4" />
        {existingDraft ? "Update Draft" : "Save as Draft"}
      </Button>
      <Button 
        onClick={handleCreateRx}
      >
        <FileCheck className="mr-2 h-4 w-4" />
        Create Rx
      </Button>
    </CardFooter>
  );
}
